import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { AppConfigService } from '../../auth/services/app-config.service';
import { Auth } from '../interfaces/auth.interface';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  private baseUrl: string = this.appConfig.config.baseUrl
  private _auth: Auth | undefined;

  get auth(): Auth {
    return {...this._auth!}
  }

  constructor( public http: HttpClient, private appConfig: AppConfigService) { }

  verifyAuthentication(): Observable<boolean> {
    if( !sessionStorage.getItem('token')) {
      return of(true); 
    }

    return this.http.get<Auth>(`${this.baseUrl}/users/1`)
      .pipe(
        map(auth => {
          this._auth = auth;
          return true
        })
      )
  }

  login() {
    return this.http.get<Auth>(`${this.baseUrl}/users/1`)
      .pipe(
        tap(auth => this._auth = auth),
        tap(auth => sessionStorage.setItem('token', auth.id.toString()))
      );
  }

  logout() {
    this._auth = undefined;
  }

}
